<template>
  <div>
    <div v-if="reloadNecessary" class="reload-status">
      Ihre Daten wurden aktualisiert, bitte laden Sie die Seite neu.
      <div class="reload-button">
        <button class="button primary" @click="onReload">Aktualisieren</button>
      </div>
    </div>
    <router-view />
    <CookieConsent />
  </div>
</template>

<script>
const reportInterval = 300000 // 300000 milliseconds = 5 minutes
var lastReportTimestamp = 0

import "@profineberater/configurator-clientlib/dist/clientlib-global.css"
import "@profineberater/configurator-clientlib/dist/library.mjs.css"
import { CookieConsent } from "@profineberater/configurator-clientlib"
import { updateGASettings } from "@profineberater/configurator-clientlib"
import UIMixin from "@/components/mixins/UiMixin"

function beforeUnloadHandler() {
  console.log("unload", window)
  window.$localDBSync?.cancel()
  window.$localContentDBSync?.cancel()
}

export default {
  name: 'App',
  mixins: [UIMixin],
  components: {
    CookieConsent
  },
  created() {
    window.$gtag = this.$gtag
    updateGASettings()
  },
  computed: {
    profile() {
      return this.$store.getters["user/profile"]
    },
    reloadNecessary() {
      return this.$store.getters["ui/reload"]
    }
  },
  methods: {
    onReload() {
      this.forceReloadAndRedirect(this.$route.path)
    },
    report() {
      let now = Date.now()
      if (lastReportTimestamp > 0 && (lastReportTimestamp + reportInterval - 11000  > now)) {
        return
      }
      lastReportTimestamp = now
      this.$store.dispatch("user/updateLastUsage", "configurator-admin")
    }
  },
  mounted() {
    window.addEventListener('beforeunload', beforeUnloadHandler);
    setTimeout(this.report, 10000);
    setInterval(this.report, reportInterval); // 300000 milliseconds = 5 minutes
  },
  beforeUnmount() {
    window.removeEventListener('beforeunload', beforeUnloadHandler);
  }
}
</script>

<style src="./fonts.css"></style>

<style>
html {
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
}

*, *:before, *:after {
  -webkit-box-sizing: inherit;
  -moz-box-sizing: inherit;
  box-sizing: inherit;
}

:root {
  --warn-color: #f23316;
  --warn-accent-color: #cd2d14;

  --primary-color: #0F7BEB;
  --emphasized-primary-color: #116de0;

  --accent-color: #228FFF;
  --text-color: rgba(103, 123, 146);

  --default-shadow-color:rgba(103, 123, 146, 0.2);
  --default-box-shadow: 0 0px 20px var(--default-shadow-color);

  --c-scrollbar-color: #c1c1c1;
  --c-scrollbar-hover-color: #a4a4a4;

  --c-white-grey: #F6F8FC;
  --c-soft-grey: #EDF1FA;
  --c-light-grey: #E6EBF7;
  --c-bright-grey: #E6E8EE;
  --c-medium-grey: #D5D8E2;
  --c-medium-grey-menu-divider: rgba(213, 216, 226, 0.1);
  --c-greyish: #AEB4CB;
  --c-deep-grey: #7882A8;
  --c-dark-grey: #555F84;
  --page-bg-color: #F7F8FA;
  --sidebar-width: 320px;
  --infobar-width: 385px;
  --error-color: #FF5F7E;
  --danger-color: #FF5F7E;
  --warning-color: #FDBC2C;

  --text-color: #677b92;
  --darkest-text-color: #000b17;

  --color-role-teamleader: rgb(224, 95, 255);
  --color-role-manager: rgb(120, 95, 255);
  --color-role-staff: rgb(47, 149, 255);

  scrollbar-color: var(--c-scrollbar-color) transparent;

  --context-menu-entry-height: 48px;
}

body {
  background: var(--page-bg-color);
  background-size: contain;
  background-attachment: fixed;
  background-repeat: no-repeat;
  margin: 0;
  padding: 0;
}

a, a:link, a:visited {
  cursor: pointer;
  font-weight: 500;
  text-decoration: none;
  color: var(--primary-color);
}

.hyphenate {
  -ms-word-break: break-all;
  word-break: break-all;
  word-break: break-word;
  -webkit-hyphens: auto;
      -moz-hyphens: auto;
      -ms-hyphens: auto;
          hyphens: auto;
}

#app {
  font-family: BioSans, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  user-select:none;
  text-align: center;
  color: var(--c-dark-blue);
  font-weight: 300;
}

.nowrap {
  white-space: nowrap;
}

.icon-button {
  min-width: 40px;
  min-height: 40px;
  cursor: pointer;
}

.icon-button.flex {
  display: flex;
  flex-direction: column;
  justify-content: center;
}

button {
  all: unset;
  cursor: pointer;
}

button.button {
  height: 54px;
  border-radius: 7px;
  letter-spacing: 1px;
  font-weight: 700;
  font-size: 14px;
  padding: 0 40px;
  white-space: nowrap;
  overflow: hidden;
  text-align: center;
  text-overflow: ellipsis;
}

button.button.tall {
  height: 54px;
}
button.button.mediumsize {
  height: 44px;
}
button.button.warning {
  background: var(--c-red);
  color: #fff;
  border-radius: 7px;
}

button.button.primary {
  background: var(--primary-color);
  border: 1px solid var(--primary-color);
  color: #fff;
  height: 52px;
}
button.button.primary.danger {
  background-color: var(--danger-color);
  border-color: var(--danger-color);
}
button.button.primary:hover {
  background: var(--accent-color);
}

button.button.primary.danger:hover {
  background-color: var(--danger-color);
  border-color: var(--danger-color);
}

button.button.primary.warn {
  background: var(--warn-color);
  border: 1px solid var(--warn-color);
}

button.button.primary.warn:hover {
  background: var(--warn-accent-color);
}

button.button.plain {
  border: none;
  color: var(--primary-color);
  cursor: pointer;
  font-weight: 500;
  font-size: 14px;
  letter-spacing: normal;
  background: none;
  padding: 0 20px;
}

button.button.plain:hover {
  background: none;
  color: #000;

}

button.button.ghost {
  border: 2px solid #000;
  color: #000;
  height: 44px;
  font-size: 14px;
  font-weight: 400;
}

button.button.ghost:hover {
  border: 2px solid var(--primary-color);
  color: var(--primary-color);
}

button.button.ghost.danger {
  border-color: var(--danger-color);
  color: var(--danger-color);
}


button.button.ghost.danger:hover {
  border-color: var(--warn-accent-color);
  color: var(--warn-accent-color);
}

button.button.ghost.tall {
  height: 52px;
}

button.button.rounded {
  border-radius: 36px;
}
button.button.mediumsize {
  height: 44px;
}
button.button.raw {
  color: var(--c-button-blue);
}

button.button:disabled, button.button.primary:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.button-group {
  display: flex;
  flex-direction: row;
  flex-grow: 1;
  justify-content: space-between;
}
.button-group .button {
  flex-grow: 1;
  margin-right: 10px;
}
.button-group .button:last-child {
  margin-right: 0;
}

.button.tab {
  background-color: #F6F7F9;
  box-shadow: inset 0 0 1px rgba(0, 0, 0, 0.15);
  height: 26px;
  margin-right: 10px;
  font-weight: 300;
  padding: 0 15px;
  font-size: 12px;
  border-radius: 3px;
}

.button.tab.active {
  background-color: var(--primary-color);
  box-shadow: inset 0 0 1px rgba(0, 0, 0, 0.15);
  color: #fff;
  font-weight: 500;
}

/* dimmer */

.dimmer {
    position: relative;
    transition: all 1s;
}

.dimmer:after {
    content: '\A';
    position: absolute;
    width: 100%;
    height: 100%;
    top:0;
    left:0;
    background: rgba(6, 50, 97, 0.5);
    opacity: 0.6;
    transition: all 0.5s;
    -webkit-transition: all 0.5s;
    -moz-transition: all 0.5s;
}

/* --- HEADLINES */

h1, h2, h3, h4, h5, h6 {
  font-weight: 600;
  color: #1E2566;
}

h1 {
  font-size: 32px;
}

h2 {
  font-size: 28px;
}

h3 {
  font-size: 24px;
}

h4 {
  font-size: 20px;
}

h5 {
  font-size: 16px;
}

h6 {
  font-size: 12px;
}

h4.widget-title {
  text-align: left;
  margin-bottom: 10px;
}

span.widget-subtitle {
  color: var(--text-color);
  display: block;
  margin: 0 0 20px 0;
  text-align: left;
}

/* --- hr */

hr.sidebar {
  height: 1px;
  width: 460px;
  border-top: 1px solid var(--c-bright-grey);
  border-bottom: none;
  border-left: none;
  border-right: none;
  transform: translateX(-40px);
}

/* --- FORMS */

form {
  text-align: left;
}
fieldset {
  all: unset;
  width: 100%;
  display: flex;
  flex-direction: column;
  margin-bottom: 20px;
  padding: 0 0 0 1px;
}

label {
  font-size: 14px;
  color: var( --c-greyish);
  text-transform: uppercase;
  letter-spacing: 1px;
  font-weight: 500;
  display: block;
  margin-bottom: 20px;
}

.dot {
    width: 6px;
    height: 6px;
    background: var(--c-deep-blue);
}

.dot.large {
    width: 10px;
    height: 10px;
}

/* Item Collection / Lists */

.item-collection ul {
    list-style-type: none;
    margin: 0;
    padding: 0;
}
.item-collection li {
    display: flex;
    flex-direction: row;
    align-content: space-between;
    align-items: center;
    background-color: #fff;
    border-radius: 7px;
    border: 1px solid var(--c-bright-grey);
    box-shadow: var(--default-box-shadow);
    padding: 20px 40px;
    cursor: pointer;
    margin-bottom: 20px;
    font-size: 14px;
    height: 108px;
    position: relative;
}
.item-collection li div.name {
    font-weight: 500;
    text-align: left;
}
.item-collection li div.name .headline-badge {
  transform: translate(0px, -4px);
}
.item-collection li div.date {
  max-width: 120px;
}
.item-collection li:hover {
    background-color: var(--c-lightgrey);
}
.item-collection li.header {
  background: #F2F4FA;
  border: 1px solid #E6EBF7;
  box-shadow: none;
  height: 48px;
  font-weight: 500;
}
.item-collection li.header > div {
  min-height: 20px;
  display: flex;
  align-items: center;
  color: #000;
}
.item-collection li.header > div.active {
  font-weight: 700;
}
.item-collection li.header > div.total-value {
  justify-content: end;
}

.item-collection > li div {
    flex-grow: 1;
    flex-basis: 0;
    text-align: left;
}
.item-collection > li div.icon {
    flex-grow: 0;
    padding-right: 20px;
}
.item-collection .actions {
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    align-items: center;
}
.item-collection .actions > * {
    margin-right: 20px;
}
.item-collection .actions > *:last-child {
    margin-right: 0;
}

.context-menu-dots {
  min-width: 40px;
  max-width: 40px;
}
.item-collection li > div {
  text-overflow: ellipsis;
  overflow: hidden;
  text-align: left;
}

.item-collection li > div:nth-child(1) {
  min-width: 5%;
  max-width: 5%;
  text-overflow: initial;
  overflow: visible;
}
.item-collection li > div:nth-child(2) {
  min-width: 25%;
  max-width: 25%;
  overflow: visible;
}
.item-collection li > div:nth-child(3) {
  min-width: 15%;
  max-width: 15%;
}
.item-collection li > div:nth-child(4) {
  min-width: 10%;
  max-width: 10%;
}
.item-collection li > div:nth-child(5) {
  min-width: 20%;
  max-width: 20%;
}
/* .item-collection li > div:nth-child(6) {
  min-width: 20%;
  max-width: 20%;
} */

.item-collection li > div:last-child {
  flex-grow: 1;
}

.item-collection li button {
  margin: 0;
}

.button-progress-wrapper {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-content: center;
  align-items: center;
  justify-items: center;
}

/* Infobox */

.info-box {
  text-align: center;
  font-size: 14px;
  line-height: 1.5;
  background-color: rgba(22, 130, 243, 0.05);
  border: 1px solid var(--primary-color);
  padding: 20px;
  border-radius: 7px;
  color: var(--emphasized-primary-color);
  font-weight: 400;
  letter-spacing: 0.35px;
}
.info-box.error {
  border: 1px solid var(--error-color);
  color: var(--error-color);
}
.info-box.warning {
  border: 1px solid var(--warning-color);
  color: var(--warning-color);
}

/* List badges */

.list-badge {
  background-repeat: no-repeat;
  background-position: 0 10px;
}
.list-badge-favorite {
  background-size: 73.64px 16px;
  background-image: url("data:image/svg+xml;base64,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")
}
.list-badge-default {
  background-size: 60.637px 16px;
  background-image: url("data:image/svg+xml;base64,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")
}

/* Loading spinner */

.lds-roller {
  display: inline-block;
  position: relative;
  width: 80px;
  height: 80px;
}
.lds-roller div {
  animation: lds-roller 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
  transform-origin: 40px 40px;
}
.lds-roller div:after {
  content: " ";
  display: block;
  position: absolute;
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background: #fff;
  margin: -4px 0 0 -4px;
}
.lds-roller div:nth-child(1) {
  animation-delay: -0.036s;
}
.lds-roller div:nth-child(1):after {
  top: 63px;
  left: 63px;
}
.lds-roller div:nth-child(2) {
  animation-delay: -0.072s;
}
.lds-roller div:nth-child(2):after {
  top: 68px;
  left: 56px;
}
.lds-roller div:nth-child(3) {
  animation-delay: -0.108s;
}
.lds-roller div:nth-child(3):after {
  top: 71px;
  left: 48px;
}
.lds-roller div:nth-child(4) {
  animation-delay: -0.144s;
}
.lds-roller div:nth-child(4):after {
  top: 72px;
  left: 40px;
}
.lds-roller div:nth-child(5) {
  animation-delay: -0.18s;
}
.lds-roller div:nth-child(5):after {
  top: 71px;
  left: 32px;
}
.lds-roller div:nth-child(6) {
  animation-delay: -0.216s;
}
.lds-roller div:nth-child(6):after {
  top: 68px;
  left: 24px;
}
.lds-roller div:nth-child(7) {
  animation-delay: -0.252s;
}
.lds-roller div:nth-child(7):after {
  top: 63px;
  left: 17px;
}
.lds-roller div:nth-child(8) {
  animation-delay: -0.288s;
}
.lds-roller div:nth-child(8):after {
  top: 56px;
  left: 12px;
}
@keyframes lds-roller {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

.lds-dual-ring {
  display: inline-block;
  width: 80px;
  height: 80px;
}
.lds-dual-ring:after {
  content: " ";
  display: block;
  width: 64px;
  height: 64px;
  margin: 8px;
  border-radius: 50%;
  border: 6px solid var(--primary-color);
  border-color: var(--primary-color) transparent var(--primary-color) transparent;
  animation: lds-dual-ring 1.2s linear infinite;
}
@keyframes lds-dual-ring {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

/* flex modifiers */

.flex {
    display: flex;
}
.flex.horizontal {
    flex-direction: row;
}
.flex.vertical {
    flex-direction: column;
}
.flex.vertical.full-height {
    align-content: space-between;
    height: 100%;
}


/* Scroll Container */

.scrollable-container {
  flex-grow: 1;
  overflow-x: hidden;
  overflow-y: scroll;
  /* for Firefox */
  min-height: 0;
  flex-grow: 1;
  flex-shrink: 1;
  flex-basis: 0;
  padding-right: 10px;
}

.scrollable-container.main {
  padding: 20px 20px 0 20px;
}

.scrollable-container.sidebar {
  padding: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

/* Scrollbar */

::-webkit-scrollbar-corner {
  background: transparent;
}

::-webkit-scrollbar {
  background: transparent;
  width: 10px;
  height: 20px;
}

/* ::-webkit-scrollbar:hover {
    background-color: #111;
} */
::-webkit-scrollbar-thumb {
  background: var(--c-scrollbar-color);
  border-radius: 16px;
  width: 10px;
}

::-webkit-scrollbar-thumb:hover {
  background: var(--c-scrollbar-hover-color);
}

.reload-status {
  background-color: #116de0;
  color: #fff;
  padding: 20px 20px 0 20px;
  font-weight: 700;
  z-index: 1000;
  position: sticky;
  top: 0;
  left: 0;
}
.reload-button {
  padding: 20px;
}
.reload-status button.primary {
  height: 24px;
  border-radius: 4px;
  margin-left: 20px;
}
/* Dev Info */

.dev-info {
  position: fixed;
  top: 10px;
  left: 10px;
  font-size: 10px;
  color: var(--c-dark-grey);
  text-align: left;
}

p.error {
  color: var(--error-color);
}
@media screen and (max-width: 1650px) {

  .scrollable-container.main {
    padding: 20px 20px 0 20px;
  }
  .button-progress-wrapper {
    max-width: 120px;
    min-width: 120px;
  }
  li button.button {
    height: 28px;
    font-size: 10px;
    padding: 0 10px;
    max-width: 100px;
  }
  .item-collection li {
    padding: 20px 20px;
  }
}

.select {
  user-select: text;
}
</style>


